import AppDrawerContent from './AppDrawerContent';

export default AppDrawerContent;
